import getItem from './get_item';
import removeItem from './remove_item';

export function getAndRemoveItem(getItem, removeItem) {
  return function execute(key) {
    const item = getItem(key);
    removeItem(key);
    return item;
  };
}

export default getAndRemoveItem(getItem, removeItem);
